"use client";

import { Box, Skeleton, Stack } from "@chakra-ui/react";
import { useThemeTokens } from "@/lib/theme/tokens";

const DEFAULT_ITEM_COUNT = 3;

export function TermsMemberNavSkeleton({
  itemCount = DEFAULT_ITEM_COUNT,
}: {
  itemCount?: number;
}) {
  const theme = useThemeTokens();

  return (
    <Box w={{ base: "100%", lg: "240px" }} flexShrink={0}>
      <Box display={{ base: "block", lg: "none" }} mb={4} w="100%">
        <Skeleton height="48px" width="100%" borderRadius="12px" />
      </Box>

      <Box
        display={{ base: "none", lg: "block" }}
        borderWidth="1px"
        borderColor={theme.borderGlass.default}
        borderRadius="12px"
        p={3}
        data-testid="terms-member-nav-sidebar-skeleton"
      >
        <Skeleton height="12px" width="56px" borderRadius="4px" mb={3} />
        <Stack spacing={1}>
          {Array.from({ length: itemCount }).map((_, index) => (
            <Skeleton
              key={index}
              height={index === 1 ? "52px" : "44px"}
              width="100%"
              borderRadius="8px"
            />
          ))}
        </Stack>
      </Box>
    </Box>
  );
}
